export default "/images/vendor/flag-icon-css/flags/1x1/se.svg?18850d25a0a36c933c5c35c1d46b4c6a";